import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import Ico from "./Icons";

const NAV_ITEMS = [
  ["/", "Accueil"],
  ["/services", "Services"],
  ["/packs", "Packs"],
  ["/realisations", "Réalisations"],
  ["/a-propos", "À propos"],
  ["/contact", "Contact"],
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobOpen, setMobOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 45);
    fn();
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  // Ferme le menu mobile à chaque changement de page
  useEffect(() => { setMobOpen(false); }, [location.pathname]);

  const navClass = (scrolled || !isHome) ? "s" : "";

  return (
    <>
      <nav className={navClass}>
        <Link className="nlogo" to="/">
          <img src="/Logo_LayeTech_Lateral.png" alt="LayeTech" onError={e => e.target.style.display = "none"} />
        </Link>
        <ul className="nlinks">
          {NAV_ITEMS.map(([path, label]) => (
            <li key={path}>
              <NavLink to={path} end={path === "/"} className={({ isActive }) => (isActive ? "active" : "")}>
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
        <Link className="ncta" to="/contact?sujet=devis">Devis gratuit <Ico name="arrowR" size={13} color="#fff" /></Link>
        <button className="nmob" aria-label="menu" onClick={() => setMobOpen(v => !v)}>
          <Ico name={mobOpen ? "xmark" : "menu"} size={22} />
        </button>
      </nav>

      {mobOpen && (
        <div className="mobmenu">
          {NAV_ITEMS.map(([path, label]) => (
            <NavLink key={path} to={path} end={path === "/"} className={({ isActive }) => (isActive ? "active" : "")}>
              {label}
            </NavLink>
          ))}
        </div>
      )}
    </>
  );
}